/**
 * RemunerationCycleOption is a constant object that defines predefined remuneration cycle options with corresponding labels and values.
 *
 * The available options include:
 *   - Year: Represents a yearly remuneration cycle.
 *   - Day: Represents a daily remuneration cycle.
 *   - Hour: Represents an hourly remuneration cycle.
 *
 * @typedef {{label: string, value: string}} RemunerationCycleFilter
 * @type {Readonly<{[key: string]: RemunerationCycleFilter}>}
 * @enum
 */
export const RemunerationCycleOption = Object.freeze({
    Year: { label: 'Year', value: 'year' },
    Day: { label: 'Day', value: 'day' },
    Hour: { label: 'Hour', value: 'hour' }
});
